import { useMutation } from "@apollo/client";
import { REMOVE_PROSPECTION } from "../prospection.queries";
import {
  RemoveProspectionMutation,
  RemoveProspectionMutationVariables,
} from "../../../__generated__/RemoveProspectionMutation";

export const useRemoveProspection = () => {
  return useMutation<RemoveProspectionMutation, RemoveProspectionMutationVariables>(
    REMOVE_PROSPECTION,
    {
      refetchQueries: "active",
    }
  );
};
